<div class="release-page">
  <div class="grain" aria-hidden="true"></div>

  <div class="container">
    <br /><br /><br />
    <br /><br />

    <h1 class="visually-hidden">{{ songTitle }} - {{ artistName }}</h1>

    <p class="presenter">ComeTralci Worship &middot; Nuovo singolo</p>

    <!-- Cover + player -->
    <div class="cover">
      <img
        *ngIf="!coverError"
        [src]="coverUrl"
        [alt]="'Copertina di ' + songTitle"
        (error)="coverError = true"
      />
      <div *ngIf="coverError" class="cover-placeholder">
        <span>{{ songTitle }}</span>
      </div>

      <div *ngIf="audioAvailable" class="preview-player">
        <audio
          #previewAudio
          [src]="previewAudioUrl"
          preload="metadata"
          (timeupdate)="onAudioTimeUpdate()"
          (ended)="onAudioEnded()"
          (error)="onAudioError()"
        ></audio>

        <button
          class="play-button"
          (click)="togglePlay()"
          [attr.aria-label]="isPlaying ? 'Pausa' : 'Ascolta l\'anteprima'"
        >
          <svg
            *ngIf="!isPlaying"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M8 5v14l11-7z" />
          </svg>
          <svg
            *ngIf="isPlaying"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" />
          </svg>
        </button>

        <div class="player-center">
          <span class="player-label">anteprima</span>
          <div class="progress-bar" (click)="seekAudio($event)">
            <div class="progress-fill" [style.width.%]="audioProgress"></div>
          </div>
        </div>

        <span class="player-time">{{ audioCurrentTime }}</span>
      </div>
    </div>

    <!-- Countdown -->
    <div *ngIf="!released" class="countdown">
      <div class="unit">
        <span class="num">{{ pad(countdown.giorni) }}</span>
        <span class="lbl">giorni</span>
      </div>
      <span class="sep">:</span>
      <div class="unit">
        <span class="num">{{ pad(countdown.ore) }}</span>
        <span class="lbl">ore</span>
      </div>
      <span class="sep">:</span>
      <div class="unit">
        <span class="num">{{ pad(countdown.minuti) }}</span>
        <span class="lbl">min</span>
      </div>
      <span class="sep">:</span>
      <div class="unit">
        <span class="num">{{ pad(countdown.secondi) }}</span>
        <span class="lbl">sec</span>
      </div>
    </div>

    <p *ngIf="released" class="released-banner">Fuori ora, ovunque.</p>

    <p *ngIf="!released" class="release-info">
      Fuori il <strong>24 luglio</strong> alle 12:00
    </p>

    <!-- Pre-save -->
    <a
      *ngIf="presaveUrl"
      [href]="presaveUrl"
      target="_blank"
      rel="noopener noreferrer"
      class="presave-button"
    >
      <div class="icon">
        <img src="/icons/spotify.svg" width="30" height="30" alt="" />
      </div>
      <div class="text">
        <span class="label">Pre-salva la canzone</span>
        <span class="sublabel">e la trovi in libreria il giorno dell'uscita</span>
      </div>
      <div class="arrow">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
        >
          <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z" />
        </svg>
      </div>
    </a>

    <!-- Email notify -->
    <div class="notify">
      <p class="notify-title">Ti avvisiamo noi quando esce</p>

      <form *ngIf="!subscribed" class="notify-form" (ngSubmit)="submitEmail()">
        <input
          type="email"
          name="email"
          [(ngModel)]="email"
          placeholder="la tua email"
          autocomplete="email"
          [disabled]="submitting"
        />
        <button type="submit" [disabled]="submitting">
          {{ submitting ? "..." : "Avvisami" }}
        </button>
      </form>

      <p
        *ngIf="subscribeMessage"
        class="notify-message"
        [class.error]="subscribeError"
      >
        {{ subscribeMessage }}
      </p>
    </div>

    <p class="stores-line">
      Dal 24 luglio su Spotify, Apple Music, YouTube Music, Amazon Music e
      tutte le altre piattaforme.
    </p>

    <!-- Social -->
    <div class="socials">
      <a
        *ngIf="youtubeUrl"
        [href]="youtubeUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="social-link"
      >
        <img src="/icons/youtube.svg" width="20" height="20" alt="" />
        YouTube
      </a>
      <a
        *ngIf="instagramUrl"
        [href]="instagramUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="social-link"
      >
        <img src="/icons/instagram.svg" width="18" height="18" alt="" />
        Instagram
      </a>
    </div>

    <!-- Footer -->
    <p class="footer-text">{{ artistName }}</p>
  </div>
</div>
